<div class="clearfix" data-testing-id="order-detail-page">
  <ng-container *ngIf="order$ | async as order">
    <ish-account-order [order]="order" />
  </ng-container>
</div>
